<template>
  <div class="ipi">
    <div class="form__field">
      <label for="Insurance">
        <span class="text-danger">*</span>
        Insurance Provider:
      </label>

      <select
        class="form-control"
        name="provider"
        id="provider"
        required
        data-required-message="Please select an insurance provider."
        ref="insuranceProviderSelect"
        v-on:change="handleProviderChange"
      >
        <option value="">Select Insurance Provider</option>
        <option v-for="provider in providers" v-bind:key="provider">
          {{ provider }}
        </option>
      </select>

      <p>
        Provider not listed?
        <button class="button-link" type="button">Click Here</button>.
      </p>
    </div>

    <div class="form__field" v-show="step >= 2">
      <label for="provider-state">
        <span class="text-danger">*</span>
        State:
      </label>

      <select
        class="form-control"
        name="provider-state"
        id="provider-state"
        required
        data-required-message="Please select a state."
        ref="providerStateSelect"
        v-on:change="handleStateChange"
      >
        <option value="">Select Provider State</option>
        <option v-for="state in states" v-bind:key="state">
          {{ state }}
        </option>
      </select>
    </div>

    <div class="form__field" v-show="step >= 3">
      <label for="provider-plan">
        <span class="text-danger">*</span>
        Plan:
      </label>

      <select
        class="form-control"
        name="provider-plan"
        id="provider-plan"
        required
        data-required-message="Please select a plan."
        ref="providerPlanSelect"
        v-on:change="handlePlanChange"
      >
        <option value="">Select Plan</option>
        <option v-for="plan in plans" v-bind:key="plan">
          {{ plan }}
        </option>
      </select>
    </div>

    <div class="form__field" v-show="step >= 4">
      <label for="provider-branch">
        <span class="text-danger">*</span>
        Product:
      </label>

      <select
        class="form-control"
        name="provider-branch"
        id="provider-branch"
        required
        data-required-message="Please select a product."
        ref="providerProductSelect"
      >
        <option value="">Select Product</option>
        <option v-for="product in products" v-bind:key="product">
          {{ product }}
        </option>
      </select>
    </div>
  </div>
</template>

<script lang="js">

  export default  {
    name: 'lms-ipi',
    data() {
      return {
        step: 1,
        apiUrl: '/app/themes/liberator/api/insdata2.php',
        providers: [],
        states: [],
        plans: [],
        products: [],
      }
    },
    async mounted () {
      await this.getProviders();
    },
    methods: {
      async getProviders() {
        const vm = this;

        // Initialized all related dependent data sets.
        vm.providers = [];
        vm.states = [];
        vm.plans = [];
        vm.products = [];

        vm.step = 1;

        try {
          let formData = new FormData();
          formData.set('type', 'init');

          const response = await fetch(vm.apiUrl, {
            method: 'POST',
            body: formData
          });

          const responseData = await response.json();

          responseData.forEach((providerInstance) => {
            vm.providers.push(providerInstance['Health Plan']);
          });
        }
        catch (error) {
          console.log(error);
        }
      },
      async getStates(provider) {
        const vm = this;

        vm.states = [];
        vm.plans = [];
        vm.products = [];

        try {
          let formData = new FormData();
          formData.set('type', 'getstate');
          formData.set('provider', provider);

          const response = await fetch(vm.apiUrl, {
            method: 'POST',
            body: formData
          });

          const responseData = await response.json();

          responseData.forEach((stateInstance) => {
            vm.states.push(stateInstance['State']);
          });
        }
        catch (error) {
          console.log(error);
        }
      },
      async getPlans(provider, state) {
        const vm = this;

        vm.plans = [];
        vm.products = [];

        try {
          let formData = new FormData();
          formData.set('type', 'getplans');
          formData.set('provider', provider);
          formData.set('state', state);

          const response = await fetch(vm.apiUrl, {
            method: 'POST',
            body: formData
          });

          const responseData = await response.json();

          responseData.forEach((plan) => {
            vm.plans.push(plan);
          });
        }
        catch (error) {
          console.log(error);
        }
      },

      async getProducts(provider, state, plan) {
        const vm = this;

        vm.products = [];

        try {
          let formData = new FormData();
          formData.set('type', 'getBranch');
          formData.set('provider', provider);
          formData.set('state', state);
          formData.set('plan', plan);

          const response = await fetch(vm.apiUrl, {
            method: 'POST',
            body: formData
          });

          const responseData = await response.json();

          responseData.forEach((product) => {
            // We want to exclude Diabetes from the list of products.
            let productCheck = product.toLowerCase();
            if (productCheck !== 'diabetes') {
              vm.products.push(product);
            }
          });

          vm.step = 4;
        }
        catch (error) {
          console.log(error);
        }
      },
      handleProviderChange() {
        const vm = this;

        const selectedProvider = vm.$refs.insuranceProviderSelect.value;

        if (selectedProvider !== '') {
          vm.getStates(selectedProvider);
        }
        else {
          vm.states = [];
          vm.plans = [];
          vm.products = [];
        }

        vm.step = 2;

      },
      handleStateChange() {
        const vm = this;

        const selectedProvider = vm.$refs.insuranceProviderSelect.value;
        const selectedState = vm.$refs.providerStateSelect.value;

        if (selectedState !== '') {
          vm.getPlans(selectedProvider, selectedState);
        }
        else {
          vm.plans = [];
          vm.products = [];
        }

        vm.step = 3;
      },
      handlePlanChange() {
        const vm = this;

        const selectedProvider = vm.$refs.insuranceProviderSelect.value;
        const selectedState = vm.$refs.providerStateSelect.value;
        const selectedPlan = vm.$refs.providerPlanSelect.value;

        if (selectedPlan !== '') {
          vm.getProducts(selectedProvider, selectedState, selectedPlan);
        }
        else {
          vm.products = [];
        }

        vm.step = 4;
      },
    },
}
</script>

<style lang="scss"></style>
